import React, { createContext, useContext, useState } from "react";

const CallPopupContext = createContext();

export const CallPopupProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [callChatData, setCallChatData] = useState(null);
  const [isCallActive, setIsCallActive] = useState(false);

  const startCall = (data) => {
    setCallChatData(data);
    setIsCallActive(true);
  };

  const endCall = () => {
    setCallChatData(null);
    setIsCallActive(false);
  };

  const openCallPopup = (data) => {
    setCallChatData(data);
    setIsOpen(true);
  };

  const closeCallPopup = () => {
    setIsOpen(false);
    setCallChatData(null);
    localStorage.removeItem("callData");
  };

  return (
    <CallPopupContext.Provider
      value={{
        isOpen,
        callChatData,
        openCallPopup,
        closeCallPopup,
        isCallActive,
        startCall,
        endCall,
      }}
    >
      {children}
    </CallPopupContext.Provider>
  );
};

export const useCallPopup = () => useContext(CallPopupContext);
